import $ from "jquery";

const API_BASE_URL = "https://api.narendramodi.in/";

export const EPISODE_LIST_URL =
  API_BASE_URL +
  "webapi/ppcepisodelist?token=T0gtBtYh1hACFYAXQg8NS1eCe5W4KAga&lang=en&type=student&index=1";
export const EPISODE_URL =
  API_BASE_URL +
  "webapi/ppcepisodedetail?token=T0gtBtYh1hACFYAXQg8NS1eCe5W4KAga";
export const EPISODE_DATA_URL =
  API_BASE_URL +
  "webapi/ppcepisodedatadetail?token=T0gtBtYh1hACFYAXQg8NS1eCe5W4KAga";

export const API_URL =
  API_BASE_URL +
  "webapi/ppcepisodehome?token=T0gtBtYh1hACFYAXQg8NS1eCe5W4KAga&lang=en&index=1";

export const share = (id, share_text, type = "detail", link) => {
  $(".popup_fixed_bg").show();
};

export const getDeviceType = () => {
  try {
    const ua = navigator.userAgent;
    if (/(tablet|ipad|playbook|silk)|(android(?!.*mobi))/i.test(ua)) {
      return "tablet";
    }
    if (
      /Mobile|iP(hone|od)|Android|BlackBerry|IEMobile|Kindle|Silk-Accelerated|(hpw|web)OS|Opera M(obi|ini)/.test(
        ua
      )
    ) {
      return "mobile";
    }
  } catch (er) {
    return "desktop";
  }
  return "desktop";
};

export const apiRequest = async (
  url,
  method = "GET",
  headers = {},
  body = null
) => {
  try {
    const options = {
      method,
      headers: {
        // "Content-Type": "application/json",
        ...headers,
      },
    };

    if (body) {
      options.body = JSON.stringify(body);
    }

    const response = await fetch(url, options);

    if (!response.ok) {
      throw new Error(`HTTP error! Status: ${response.status}`);
    }

    return await response.json();
  } catch (error) {
    console.error("API Request Error:", error.message);
    throw error;
  }
};

export const playpause = (video_id, type) => {

  let playpausebtn = ".playpausebtn_" + video_id;
  $(".vjs-tech").each(function () {
    $(this).get(0).pause();
    $(".play_icon").attr("src", "/assets/images/play2.svg");
    if ($(this)[0].playerId != "myVideo_" + type + "_" + video_id) {
      $(this).attr("data-playpause", "1");
    }
  });
  let videoid = "myVideo_" + type + "_" + video_id + "_html5_api";

  let el = $("#" + videoid).get(0);
  console.log("element", el);
  let data_play = $("#" + videoid).attr("data-playpause");
  data_play = data_play ? data_play.toString() : data_play;

  if (data_play && data_play == 1) {
    console.log("1")
    $("#" + videoid).attr("data-playpause", "0");
    $(playpausebtn).attr("src", "/assets/images/pause.svg");
    $(playpausebtn).fadeOut();
    el.play();
  } else if (!data_play) {
    $("#" + videoid).attr("data-playpause", "0");
    $(playpausebtn).attr("src", "/assets/images/pause.svg");
    el.play();
    $(playpausebtn).fadeOut();
    console.log("2")
    // $('.videoplay_icon').show();
  } else {
    $("#" + videoid).attr("data-playpause", "1");
    $(playpausebtn).attr("src", "/assets/images/play2.svg");
    el.pause();
    $(playpausebtn).fadeIn();
    console.log("3")
    // $('.videoplay_icon').show();
  }
};
export const pauseVideo = (video_id, Type) => {
  let playpausebtn = ".playpausebtn_" + video_id;
  $(".vjs-tech").each(function () {
    $(this).get(0).pause();
    $(".play_icon").attr("src", "/assets/images/play2.svg");
    if ($(this)[0].playerId != "myVideo_" + Type + "_" + video_id) {
      $(this).attr("data-playpause", "1");
    }
  });
  let videoid = "myVideo_" + Type + "_" + video_id + "_html5_api";

  let el = $("#" + videoid).get(0);
};

export const hideplayIcon = (video_id, type) => {
  let timeout = null;
  if (timeout) {
    clearTimeout(timeout);
  }
  let playpausebtn = ".playpausebtn_" + video_id;

  let videoid = "myVideo_" + type + "_" + video_id + "_html5_api";
  let data_play = $("#" + videoid).attr("data-playpause");
  if (data_play == 0) {
    timeout = setTimeout(() => {
      $(playpausebtn).fadeOut();
    }, 500);
  } else {
    $(playpausebtn).fadeIn();
  }
};

export const handlePlayerReady = (player) => {
  // you can handle player events here
  player.on("waiting", () => {
    console.log("player is waiting");
  });
  player.on("play", () => {
    $(".videoplay_icon").hide();
    // console.log('playing');F
  });
  player.on("dispose", () => {
    console.log("player will dispose");
  });
};
